<template>
    <div class="main">
        <div style="font-size: 0;">
            <img class="brand-img" v-for="imgItem, imgIndex in urlList" :key="imgIndex" :src="imgItem" alt="" @click="viewImg(imgIndex)">
            <div v-if="type == 1" class="text-box font28">
                <!-- <div v-for="item, index in introduceText" :key="index">{{ item }}</div> -->
                <div>贝黎诗（PALAISPA），美丽田园集团旗下高端美容连锁品牌。成立于2005年。自品牌成立以来，贝黎诗始终坚持专业 、演绎时尚 、诠释知性。不遗余力全方位提升服务。 </div>
                <br>
                <div>甄选全球前沿护理产品 </div>
                <div>&nbsp;&nbsp;&nbsp;&nbsp;贝黎诗不断探索引进全球前沿护肤产品和最新护肤科技仪器，与欧洲护肤品研发中心共享傲人成果和丰富经验。独家研发安全、有效、特色的产品和护理疗程，</div>
                <br>
                <div>引进国际先进美容理念 </div>
                <div>&nbsp;&nbsp;&nbsp;&nbsp;贝黎诗引进全球先进美容理念，重视健康，回归自然、更具疗效性和复合功能，全新诠释奢华有机、高科技革新理念支撑的五星级美容服务。 </div>
                <br>
                <div>不遗余力提升服务标准 </div>
                <div>&nbsp;&nbsp;&nbsp;&nbsp;贝黎诗全新【艺术&美肤 空间】理念，打造极致优雅的护理环境，独家「PALAISPA」手法带来五星级专业护理体验，量肤定制化疗程护理方案，只为带给您至甄享受。 </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ImagePreview } from 'vant'

    export default {
        name: 'blsBrandDetail',
        components: {
            ImagePreview
        },
        data() {
            return {
                type: 0,
                // introduceText: [
                //     '美丽田园（Beauty Farm）作为美丽田园医疗健康产业有限公司的旗舰品牌，于1993年成立，是中国美丽与健康管理服务行业中成立已久的国内知名连锁品牌之一。',
                //     '30年不断深耕，从美丽田园创立之初就开始引进国际美容理念，并使用先进的护理技术、产品仪器、质控流程、服务标准，为每位客人带来舒适的美容美体护理服务。随着国内科技水平的飞速跃进，我们也开始与业内第一梯队的生物科技公司携手共创美容新技术。',
                //     '我们致力于美与健康的发展，持续科技革新，坚守品牌价值，坚持系统化标准化管理和美与健康一站式服务，为顾客提供舒适的美与健康新体验。',
                //     '2023年1月16日，美丽田园医疗健康产业有限公司作为中国最大的（按2021年收益计）传统美容服务提供商，成功登录香港联合交易所有限公司主板（股份代号：2373.HK），在创立30周年之际开启崭新历程。'
                // ],
                urlList: []
            }
        },
        mounted() {
            this.type = this.$route.query.type
            switch (this.type) {
                case 1:
                    document.title = '品牌介绍'
                    this.urlList = ['https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/blsWarehouse/brand01.png']
                    break
                case 2:
                    document.title = '品牌历程'
                    this.urlList = ['https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/blsWarehouse/brand02.png']
                    break
                case 3:
                    document.title = '品牌荣誉'
                    this.urlList = ['https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/blsWarehouse/brand03.png']
                    break
                case 4:
                    document.title = '品牌服务'
                    this.urlList = [
                        'https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/blsWarehouse/brand04_1.jpg',
                        'https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/blsWarehouse/brand04_2.jpg',
                        'https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/blsWarehouse/brand04_3.jpg',
                        'https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/blsWarehouse/brand04_4.jpg',
                    ]
                    break
                case 5:
                    document.title = '门店环境'
                    break
                case 6:
                    document.title = '企业文化'
                    this.urlList = ['https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/blsWarehouse/brand05.jpg']
                    break
            }
        },
        methods: {
            viewImg(index) {
                ImagePreview([this.urlList[index]])
            }
        }
    }
</script>

<style scoped>
    .main {
        height: 100%;
        width: 750px;
        background: #fff;
        overflow-y: auto;
    }

    .brand-img {
        width: 100%;
        height: auto;
    }

    .text-box {
        padding: 40px 40px 0 30px;
        color: #35434c;
        letter-spacing: 1px;
        line-height: 42px;
    }

    img {
        margin: 0;
        padding: 0;
    }
</style>